import { Locale, Step } from 'react-joyride';

// localeプロパティで日本語化用
export const jaJoyrideLocale: Locale = {
  back: '戻る',
  close: '閉じる',
  last: '終了',
  next: '次へ',
  skip: 'スキップ',
  open: '開く',
};

// react-joyrideのステップを定義する
export const aiAssistantJoyrideSteps: Step[] = [
  {
    target: '.joyride-global-nav-button',
    disableBeacon: true,
    content: (
      <>
        <strong>新機能「AIアシスタント」が使えるようになりました。</strong>
        <br />
        ClarisLinkの使い方で困ったときは、まずここを押してAIに聞いてみてください。
      </>
    ),
  },
  {
    target: '.joyride-ai-input',
    content: (
      <>
        <strong>こちらがAIアシスタントとの会話スペースです。</strong>
        <br />
        わからないことがあれば、メッセージを入力してみてください。
      </>
    ),
    placement: 'left',
    disableBeacon: true,
  },
];
